import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import './App.css'
import AdminTable from './components/AdminTable'

const LOGIN_KEY = 'isLogged'
const LOGIN_TIME_KEY = 'loginTime'
const MAX_VALIDITY_MS = 6 * 60 * 60 * 1000

export default function App() {
    const [logged, setLogged] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        if (params.get('login') === 'success') {
            const now = Date.now()
            localStorage.setItem(LOGIN_KEY, 'true')
            localStorage.setItem(LOGIN_TIME_KEY, now.toString())
            setLogged(true)
            window.history.replaceState({}, document.title, window.location.pathname)
        } else if (params.get('login') === 'error') {
            Swal.fire({ icon: 'error', title: 'Chyba', text: 'Nemáte povolení' })
            window.history.replaceState({}, document.title, window.location.pathname)
        } else {
            const stored = localStorage.getItem(LOGIN_KEY) === 'true'
            const time = parseInt(localStorage.getItem(LOGIN_TIME_KEY) || '0', 10)
            if (stored && Date.now() - time < MAX_VALIDITY_MS) {
                setLogged(true)
            } else if (stored) {
                // platnost vypršela
                handleLogout(false)
            }
        }
    }, [])

    const handleDiscordLogin = () => {
        window.location.href = 'https://api.lexikonn.eu/admin/lgn.php'
    }

    const handleLogout = (showAlert = true) => {
        localStorage.removeItem(LOGIN_KEY)
        localStorage.removeItem(LOGIN_TIME_KEY)
        setLogged(false)
        if (showAlert) Swal.fire({ icon: 'info', title: 'Odhlášeno' })
    }

    return (
        <div className="App">
            {!logged ? (
                <button onClick={handleDiscordLogin} className="btn btn-warning mt-4 btn-sm">
                    Přihlásit přes Discord
                </button>
            ) : (
                <button onClick={() => handleLogout(true)} className="btn btn-secondary mt-4 btn-sm">
                    Odhlásit
                </button>
            )}
            <AdminTable isEditable={logged} />
        </div>
    )
}
